
import React      from 'react';
import CSSModules from 'react-css-modules';

import stylingUtils from '../../services/stylingUtilities';
import classNames   from 'classnames/bind';

import style from './style.scss';

class SideBar extends React.Component {

    _getSideBarClass() {

        var cx = classNames.bind(style);

        var baseClassNames = {
            'side-bar': true
        };

        return cx(stylingUtils.mergeClassNames(
            baseClassNames, this.props.className
        ));
    }

    render() {

        return (
            <aside className={ this._getSideBarClass() }>

                { this.props.children }

            </aside>
        );
    }
}

export default CSSModules(SideBar, style);


// WEBPACK FOOTER //
// ./components/SideBar/index.js